export { default as mapAgencyBreadcrumbs } from './map-agency-breadcrumbs';
export { default as mapContactBreadcrumbs } from './map-contact-breadcrumbs';
export { default as mapHeaderData } from './map-header-data';
export { default as mapSearchResultsBreadcrumbs } from './map-search-results-breadcrumbs';

export interface Breadcrumb {
  title: string;
  url: string;
}
